import React, { useContext, useEffect, useState } from "react";
import { Layout } from "flexlayout-react";
import "flexlayout-react/style/light.css";

import { StoreContext } from "../../../store/Store";
import { LocalStoreContext } from "../store/LocalStore";
import { LayoutContext } from "../store/LayoutContext";
import { GlobalRefContext } from "../../../store/GlobalRefs";
import { RefContext } from "../store/RefContext";
import { actionTypes } from "../../../store/storeTypes";
import { actionTypes as lactionTypes } from "../store/storeTypes";
import { storedValueData } from "../../../api/s3";
import {
  factory,
  layoutModelChange,
  onRenderTab,
  onRenderTabSet,
} from "./layoutFunctions";
import "../../../layout/layoutstyle.css";

export const StoredValueLayout = () => {
  const [store, dispatch] = useContext(StoreContext);
  const [lstore, ldispatch] = useContext(LocalStoreContext);
  const [layoutState] = useContext(LayoutContext);
  const refs = useContext(RefContext);
  const grefs = useContext(GlobalRefContext);
  const { auth, controlPopupMenu, debug, defaultTicker } = store;
  const { storedValue } = lstore;

  if (debug) {
    console.log("StoredValueLayout");
  }

  const [selectedstoredValueTicker, setStoredValueTicker] = useState();
  const [selectedstoredValueHorizon, setStoredValueHorizon] = useState();

  useEffect(() => {
    if (
      controlPopupMenu.selected["storedValueTicker"] &&
      controlPopupMenu.selected["storedValueHorizon"]
    ) {
      setStoredValueTicker(controlPopupMenu.selected["storedValueTicker"]);
      setStoredValueHorizon(controlPopupMenu.selected["storedValueHorizon"]);
    }
  }, [controlPopupMenu.selected, defaultTicker]);

  useEffect(() => {
    let isCancelled = false;
    if (auth) {
      if (selectedstoredValueTicker) {
        if (
          refs.storedValueSelections.current.currentTicker !==
          selectedstoredValueTicker
        ) {
          const asyncfunction = async () => {
            refs.storedValueSelections.current.currentTicker =
              selectedstoredValueTicker;

            const newState = {
              rawdata: [],
              filteredData: [],
            };
            ldispatch({ type: actionTypes.SET_LOADING, payload: true });
            const data = await storedValueData(
              auth,
              selectedstoredValueTicker,
              grefs.storedValueStorage.current
            );
            if (!isCancelled) {
              newState.rawdata = data;
              newState.filteredData = data.filter((item) => {
                return (
                  item["Horizon"] ===
                  refs.storedValueSelections.current.currentHorizon
                );
              });
              ldispatch({
                type: lactionTypes.SET_STOREDVALUE,
                payload: newState,
              });
              ldispatch({ type: actionTypes.SET_LOADING, payload: false });
            }
          };
          //get data from s3
          asyncfunction();
        }
      }
    }
    return () => {
      isCancelled = true;
    };
  }, [
    auth,
    selectedstoredValueTicker,
    ldispatch,
    dispatch,
    grefs.storedValueStorage,
    refs.storedValueSelections,
  ]);

  useEffect(() => {
    if (
      refs.storedValueSelections.current.currentHorizon !==
      selectedstoredValueHorizon
    ) {
      const newState = storedValue;
      refs.storedValueSelections.current.currentHorizon =
        selectedstoredValueHorizon;
      newState.filteredData = newState.rawdata.filter((item) => {
        return item["Horizon"] === selectedstoredValueHorizon;
      });
      ldispatch({
        type: lactionTypes.SET_STOREDVALUE,
        payload: newState,
      });
    }
  }, [
    selectedstoredValueHorizon,
    storedValue,
    ldispatch,
    refs.storedValueSelections,
  ]);

  if (layoutState.model) {
    return (
      <Layout
        ref={layoutState.layout}
        model={layoutState.model}
        factory={factory}
        onRenderTabSet={(tabSetNode) => onRenderTabSet(tabSetNode, refs)}
        onModelChange={(model) => layoutModelChange(model, grefs)}
        onRenderTab={(node, renderState) =>
          onRenderTab(node, renderState, refs.componentSize)
        }
      />
    );
  } else return null;
};
